<cx-org-sub-list [showHint]="true">
  <a actions class="link" routerLink="assign">
    {{ 'organization.assign' | cxTranslate }}
  </a>
</cx-org-sub-list>
